import isEmpty from "../helpers/isEmpty";
//------------------------
// calc damage mod ranged
//------------------------
export default function calcDamageModRanged(str, siz) {
  // console.log("------------------------")
  // console.log("IN calcDamageModRanged")
  let tot = str + siz;
  // console.log("str = " + str + " siz = " + siz + " tot = " + tot)

  let mod = "";
  if (isEmpty(str) || isEmpty(siz)) {
    return "Missing Characteristics";
  } else {
    switch (true) {
      case tot < 6:
        mod = "-D4";
        break;
      case tot > 5 && tot < 11:
        mod = "-D3";
        break;
      case tot > 10 && tot < 16:
        mod = "-D2";
        break;
      case tot > 15 && tot < 21:
        mod = "-1";
        break;
      case tot > 20 && tot < 26:
        mod = "0";
        break;
      case tot > 25 && tot < 31:
        mod = "+1";
        break;
      case tot > 30 && tot < 36:
        mod = "+D2";
        break;
      case tot > 35 && tot < 41:
        mod = "+D3";
        break;
      case tot > 40 && tot < 46:
        mod = "+D4";
        break;
      case tot > 45 && tot < 51:
        mod = "+D5";
        break;
      case tot > 50 && tot < 61:
        mod = "+D6";
        break;
      case tot > 60 && tot < 71:
        mod = "+2D3";
        break;
      case tot > 70 && tot < 81:
        mod = "+2D4";
        break;
      case tot > 80 && tot < 91:
        mod = "+2D5";
        break;
      case tot > 90 && tot < 101:
        mod = "+2D6";
        break;
      default:
        mod = "Missing Characteristics";
    }
    return mod;
  }
}
